import React, { Component } from 'react';
import TaggedImage from './../taggedImage';

export default class LookBookFullWidthImage extends Component {

  render() {
    return(
      <div>
        {this.props.image &&
            <div
              className={"full-width"} style={{overflow:"hidden"}}
            >
              {this.props.latlng ?
                <TaggedImage
                  image={this.props.image}
                  backgroundImage={this.props.backgroundImage}
                  latlng={this.props.latlng}
                  city={this.props.city}
                />
              :
                <img className="full-width"
                  src={this.props.image}
                  backgroundImage={this.props.backgroundImage}
                />
              }
            </div>
          }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/lookBookFullWidthImage/index.js